import React, { useCallback, useEffect } from 'react';
import { ApiUrl, AppPages } from '../../project/Defines';
import { EVENT_NAME } from '../../project/utilities';
import ListView from '../../Shared/ListView';
import { COLUMN_TYPE } from '../../Shared/ListView/helper';
import { Project } from '../../project/Project';
import InputCont from '../../Shared/Form/InputCont';
import { openPopup } from '../../store/actions';
import { connect, useDispatch } from 'react-redux';
import { PopupTypes } from '../../components/Popup';
import i18n from '../../Shared/Translation/i18n';
import { Ajax } from '../../components/Ajax';
import { hideLoader, showLoader } from '../../Shared/Loader';
import { message } from 'antd';

const loaderName = 'MAINTENANCE_LOADER';

 function SalesNetwork(props) {
    const [isInMaintenance, setIsInMaintenance] = React.useState(false);
    const dispatch = useDispatch();
    const columns = [
        {
            text: 'text.name',
            field: 'name',
            type: COLUMN_TYPE.TEXT
        },
        {
            text: 'text.code',
            field: 'code',
            type: COLUMN_TYPE.TEXT
        },
        {
            text: 'text.sso',
            field: 'ssoName',
            type: COLUMN_TYPE.TEXT
        },
        {
            text: 'text.cookiebot',
            field: 'cookiebot',
            type: COLUMN_TYPE.TEXT
        },
        {
            text: 'text.aquamede',
            field: 'aquamede',
            render: (value) => { 
                return <wrap>
                            {value &&
                                <wrap>
                                    <item>
                                        <icon>done</icon>
                                    </item>
                                 </wrap>
                            }
                        </wrap>
            }, 
            type: COLUMN_TYPE.TEXT
        },
        {
            text: 'text.thercodim',
            field: 'thercodim',
            render: (value) => { 
                return <wrap>
                            {value &&
                                <wrap>
                                    <item>
                                        <icon>done</icon>
                                    </item>
                                 </wrap>
                            }
                        </wrap>
            }, 
            type: COLUMN_TYPE.TEXT
        },
        {
            text: 'text.urlAquamede',
            field: 'urlAquamede',
            type: COLUMN_TYPE.TEXT
        },
        {
            text: 'text.urlThercodim',
            field: 'urlThercodim',
            type: COLUMN_TYPE.TEXT
        },
        {
            text: 'text.code_localisation',
            field: 'code_localisation',
            type: COLUMN_TYPE.TEXT
        },
        {
            text: 'text.code_reseau_commercial',
            field: 'code_reseau_commercial',
            type: COLUMN_TYPE.TEXT
        },
        {
            type: COLUMN_TYPE.ACTION
        }
    ];

    useEffect(() => {
            Ajax.get({
                url: ApiUrl.GetMaintenance,
                data: { application: "thermodim" },
                success: function (response) {
                    if (response && !response.HasError) {
                        setIsInMaintenance(response.isInMaintenance);
                    } else {
                        message.error();
                    }
                },
            })
    }, []);

    const onChangeMaintenance = useCallback((e) => {
        dispatch(openPopup({
            windowKey:  'wndConfirmDrop',
            type: PopupTypes.Confirm,
            title: "Maintenance Thercodim",
            text: e.target.checked ? i18n('text.maintenance_on_confirmation') : i18n('text.maintenance_off_confirmation'),
            fullScreen: false,
            buttonYesText: i18n('text.ok'),
            buttonNoText: i18n('text.cancel'),
            disableOutsideClick: true,
            yesCallback: () => {
                showLoader(loaderName);
                Ajax.post({
                    url: ApiUrl.ThercodimSetMaintenance,
                    data: {
                       isInMaintenance: e.target.checked,
                       application: "thermodim"
                    },
                    success: (response) => {
                        hideLoader(loaderName);
                    }
                });
            },
            noCallback: () => {
                setIsInMaintenance(!e.target.checked);
            }
        }));

        setIsInMaintenance(e.target.checked);
    }, [dispatch])

    return (
       <div>
           <ListView
               listName={'sales_network'}
               columnConfig={columns}
               apiUrl={ApiUrl.SalesNetworkList}
               deleteUrl={ApiUrl.SalesNetworkDelete}
               detailUrl={Project.getPageUrl(AppPages.SalesNetworkDetails)}
               listUpdateEvent={EVENT_NAME.SALES_NETWORK_LIST_UPDATE}
               nameField="name"
           />
           <div style={{'minWidth': '500px',  "margin": "10px"}}><InputCont label={"Maintenance Thercodim"} inputProps={{  name: "item.appLabel", type: 'checkbox', value: "item.applicationId",  checked: isInMaintenance, onChange:onChangeMaintenance}} /></div>
        </div>
    );
}


export default connect()(SalesNetwork);